import { ISnackbarProps, MuiAlertSnackbar, SnackbarState } from '.';
import { SnackbarContext } from './context';
import { useSnackbarAlert } from './use-snackbar-alert';

export const SnackbarContextProvider = ({
	children,
	initialState,
	variant
}: {
	children: React.ReactNode;
	initialState?: Partial<SnackbarState>;
	/** Default presentation for snackbars from this provider; an individual `setSnackbar({ variant })` overrides it. */
	variant?: ISnackbarProps['variant'];
}) => {
	const [snackbar, setSnackbar] = useSnackbarAlert(initialState);
	const closeSnackbar = () => {
		setSnackbar({ open: false });
	};
	return (
		<SnackbarContext.Provider value={{ snackbar, setSnackbar, closeSnackbar }}>
			{children}
			<MuiAlertSnackbar {...snackbar} variant={snackbar.variant ?? variant} onClose={closeSnackbar} />
		</SnackbarContext.Provider>
	);
};
